const createCustomerReceipt = (order, settings, t) => {
  const { items = [], order_number } = order;
  const date = new Date();
  const formattedDate = new Intl.DateTimeFormat('ar-SA', {
    calendar: 'gregory',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).format(date);
  
  // Get paper dimensions from settings
  const { printing } = settings;
  const paperWidth = printing?.paper_size || '80mm';
  const paperHeight = printing?.paper_height || 'auto';
  const fontSize = printing?.font_size || '10';

  // Calculate dimensions with space for RTL text
  const pageWidth = parseInt(paperWidth);
  const contentWidth = pageWidth - 10; // Space for margin
  const heightStyle = paperHeight === 'auto' ? 'auto' : `height: ${paperHeight}mm;`
  
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        @page {
          margin: 0;
          size: ${pageWidth}mm ${heightStyle};
        }
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
          font-size: ${fontSize}pt;
        }
        body {
          width: ${pageWidth}mm;
          ${heightStyle}
          margin: 0 auto;
          padding: 0;
        }
      </style>
    </head>
    <body>
      <div style="
        font-family: Tahoma, Arial, sans-serif;
        width: ${contentWidth}mm;
        text-align: center;
        direction: rtl;
        padding: 0 2mm;
        margin: 0 auto;
      ">
      <div style="border-bottom: 1px solid #000; padding: 2px 0;">
        ${formattedDate}
      </div>
      <div style="border-bottom: 1px solid #000; padding: 2px 0;">
        رقم الطلب: [ ${order_number || ''} ]
        <br/>
        محلي
      </div>

      <table style="width: 100%; border-collapse: collapse; margin-top: 5px;">
        <thead>
          <tr>
            <th style="border-bottom: 1px solid #000; padding: 5px; text-align: center;">No.</th>            
            <th style="border-bottom: 1px solid #000; padding: 5px; text-align: right;">اسم الصنف</th>
            <th style="border-bottom: 1px solid #000; padding: 5px; text-align: center;">الكمية</th>
          </tr>
        </thead>
        <tbody>
          ${items.map((item, index) => `
            <tr>
              <td style="padding: 2px; text-align: center; width: 15%;">${index + 1}</td>              
              <td style="padding: 2px; text-align: right; width: 60%;">${item.name_ar || item.name}</td>
              <td style="padding: 2px; text-align: center; width: 25%;">${item.quantity}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      </div>
    </body>
    </html>
  `;
};

export default createCustomerReceipt;
